import { render } from "./VFormGroupReadOnlyText.vue?vue&type=template&id=5b14aa12&scoped=true&ts=true"
import script from "./VFormGroupReadOnlyText.vue?vue&type=script&lang=ts"
export * from "./VFormGroupReadOnlyText.vue?vue&type=script&lang=ts"

import "./VFormGroupReadOnlyText.vue?vue&type=style&index=0&id=5b14aa12&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b14aa12"]])

export default __exports__